import React from 'react';
import { ERROR_RENDERS } from './ErrorConst';
import './style.scss';

const ErrorBoxMessage = ({ errorToRender = 'PAGE_NOT_FOUND' }) => {
  const ERROR_TO_DISPLAY = ERROR_RENDERS[errorToRender];
  let errorImage = ERROR_TO_DISPLAY.errorImage;
  let errorText = ERROR_TO_DISPLAY.errorText;
  let errorTextStyling = ERROR_TO_DISPLAY.errorTextStyling;
  return (
    <div className="error-message">
      {errorImage && <img className="error-icon" src={errorImage} alt={'error icon'} />}
      {errorText && (
        <div className="error-text" style={errorTextStyling}>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default ErrorBoxMessage;
